import React from "react";
import { DroneDetailsProps } from "../../../types";

// Helper function to format the date string into "Month Day, Year"
const formatDate = (dateString: string): string => {
  if (!dateString) return "Date not available";
  try {
    const date = new Date(dateString);
    // If invalid, fall back to the date part before 'T' if available
    if (isNaN(date.getTime())) {
      return dateString.split('T')[0] || dateString;
    }
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return date.toLocaleDateString('en-US', options);
  } catch {
    return dateString.split('T')[0] || "Invalid Date";
  }
};

const DroneDetails: React.FC<DroneDetailsProps> = ({
  droneName,
  location,
  timestamp,
}) => (
  <div className="px-4">
    <h2 className="text-base text-primary font-ubuntu font-medium mb-6">
      {droneName}
    </h2>
    <div className="flex justify-between items-center text-primary font-ubuntu text-sm">
      <span>{location}</span>
      <span>{formatDate(timestamp)}</span>
    </div>
  </div>
);

export default DroneDetails;
